export default function MaintenanceHero() {
  return (
    <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20technician%20working%20on%20modern%20HVAC%20system%20maintenance%20in%20clean%20industrial%20setting%20with%20tools%20and%20equipment%20simple%20white%20background%20high%20quality%20professional%20photography%20bright%20lighting%20technical%20precision%20work%20environment%20safety%20equipment%20modern%20technology&width=1920&height=600&seq=maint001&orientation=landscape"
          alt="Maintenance CVSE professionnelle"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>
      <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-8 py-32 text-center">
        <div className="inline-flex items-center gap-2 bg-red-600 text-white px-4 py-2 rounded-full mb-6">
          <i className="ri-alarm-warning-line text-xl"></i>
          <span className="font-semibold text-sm">Service d'urgence 24h/24 et 7j/7</span>
        </div>
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
          Maintenance et Dépannage<br /><span className="text-orange-400">CVSE en Suisse</span>
        </h1>
        <p className="text-xl text-white/80 max-w-3xl mx-auto mb-8">
          Interventions rapides et professionnelles pour tous vos besoins en chauffage, ventilation, sanitaire et électricité. Service d'urgence disponible 24h/24 et 7j/7 dans toute la Suisse romande.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="#contact"
            className="inline-flex items-center justify-center gap-2 bg-red-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-red-700 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-alarm-warning-line text-xl"></i>
            Demande d'urgence
          </a>
          <a
            href="#contact"
            className="inline-flex items-center justify-center gap-2 bg-orange-500 text-white px-8 py-4 rounded-lg font-semibold hover:bg-orange-600 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calendar-line text-xl"></i>
            Planifier une maintenance
          </a>
        </div>
      </div>
    </section>
  );
}
